<template>
    <div class="indexNews" id="tabs" data-aos="fade-up" data-aos-duration="1550">
        <div class="news-title">
        <h5 v-if="lang!='en'">Center News</h5>
        <h3>{{ $t('INDEX.CENTERNEWS') }}</h3>
        </div>
        <ul id="ulName">
            <li :data-sortby="newsIndex"><a href="#news"  :class="{'a-font-size-en':lang=='en'}" >{{ $t('HEADER.LATESTNEWS') }}</a></li>
            <li :data-sortby="mediaIndex"><a href="#media" :class="{'a-font-size-en':lang=='en'}" >{{ $t('HEADER.MEDIA') }}</a></li>
            <li :data-sortby="worldIndex"><a href="#world" :class="{'a-font-size-en':lang=='en'}" >{{ $t('HEADER.WORLDNEWS') }}</a></li>
        </ul>
        <div id="news" style="padding:1em 1.4em">
            <div class="detailed-con" v-if="news.length == 0 && !isLoading" >
                <div class="oops">
                    <img src="../../../../static/images/10/oops.png" alt="">
                </div>
            </div>
            <ul v-if="news.length > 0">
                <li class="news-box1">
                    <a :href="item.data.is_link ? item.data.link : '/news/' + item.id" :target="item.data.is_link ? '_blank' : false"  v-for="(item, index) in news" :key="item.id" v-if="index < 1" >
                        <div class="news-box1-img" :style="{ 'background-image': 'url(' + item.data.src + ')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>
                        <p>{{item.data.desc.replace(/<[^>]+>/g, '').replace(/&(nbsp|amp|quot|lt|gt|ndash);/g, '')}}</p>
                        <div class="timeBox">
                            <p class="time">{{item.data.date}}  ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
                <li class="news-box2">
                    <a :href="item.data.is_link ? item.data.link : '/news/' + item.id" :target="item.data.is_link ? '_blank' : false"  v-for="(item, index) in news" :key="item.id" v-if="index >= 1  && index < 5" >
                        <div class="news-box2-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>      
                        <div>
                            <p class="time">{{item.data.date}} ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
            </ul>
            <a class="all" href="/news">view all</a>
        </div>
        <div id="media" style="padding:1em 1.4em">
            <div class="detailed-con" v-if="media.length == 0 && !isLoading">
                <div class="oops">
                    <img src="../../../../static/images/10/oops.png" alt="">
                </div>
            </div>
            <ul v-if="media.length > 0">
                <li class="news-box1">
                    <a :href="item.data.is_link ? item.data.link : '/media/' + item.id" :target="item.data.is_link ? '_blank' : false"  v-for="(item, index) in media" :key="item.id" v-if="index < 1" >
                        <div class="news-box1-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>
                        <p>{{item.data.desc.replace(/<[^>]+>/g, '').replace(/&(nbsp|amp|quot|lt|gt|ndash);/g, '')}}</p>
                        <div class="timeBox">
                            <p class="time">{{item.data.date}}  ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
                <li class="news-box2">
                    <a :href="item.data.is_link ? item.data.link : '/media/' + item.id" :target="item.data.is_link ? '_blank' : false" v-for="(item, index) in media" :key="item.id" v-if="index >= 1  && index < 5" >
                        <div class="news-box2-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>      
                        <div>
                            <p class="time">{{item.data.date}} ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
            </ul>
            <a class="all" href="/media">view all</a>
        </div>
        <div id="world" style="padding:1em 1.4em">
            <div class="detailed-con" v-if="world.length == 0 && !isLoading">
                <div class="oops">
                    <img src="../../../../static/images/10/oops.png" alt="" />
                </div>
            </div>
            <ul v-if="world.length > 0">
                
                <li class="news-box1">
                    <a :href="item.data.is_link ? item.data.link : '/world/' + item.id" :target="item.data.is_link ? '_blank' : false" v-for="(item, index) in world" :key="item.id" v-if="index < 1" >
                        <div class="news-box1-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>
                        <p>{{item.data.desc.replace(/<[^>]+>/g, '').replace(/&(nbsp|amp|quot|lt|gt|ndash);/g, '')}}</p>
                        <div class="timeBox">
                            <p class="time">{{item.data.date}}  ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
                <li class="news-box2">
                    <a :href="item.data.is_link ? item.data.link : '/world/' + item.id" :target="item.data.is_link ? '_blank' : false" v-for="(item, index) in world" :key="item.id" v-if="index >= 1  && index < 5" >
                        <div class="news-box2-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" alt=""></div>
                        <h4>{{item.data.title}}</h4>      
                        <div>
                            <p class="time">{{item.data.date}} ｜  {{item.data.list_selected_name}}</p>
                        </div>
                    </a>
                </li>
            </ul>
            <a class="all" href="/world">view all</a>
        </div>
    </div>
</template>
<script>
import {fb, db } from '../../../firebase'
export default {
    name: 'IndexNews',
    data () {
        return {
            news:[],
            media:[],
            world:[],
            datas:[],
            newsIndex:1,
            worldIndex:2,
            mediaIndex:3,
            isLoading:true,
            lang:''
        }
    },
    mounted () {
        this.lang = localStorage.getItem('language') || 'zh';
        this.GetCatgory();
    },
    methods: {
        FindName(id, selected) {
            var list = this.datas.find(x => x.id === id).data.list;

            if (list.find(x=>x.id == selected) ) {
                return list.find(x=>x.id == selected).name;
            } 
            return '';
        },
        GetCatgory() {
            db.collection( this.$t('DB.CATEGORY') ).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    var data = {"id": doc.id, "data": doc.data()};
                    
                    this.datas.push(data);
                    
                });

                this.Get();
                
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
        },
        Get(){
            // 取得列表
            var all = [];
            db.collection(this.$t('DB.NEWS')).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    var item = doc.data();
                    item.list_selected_name =  this.FindName(doc.data().selected, doc.data().list_selected);
                    var data = {"id": doc.id, "data": item};
                    if ( doc.data().selected == 'news') this.news.push(data);
                    if ( doc.data().selected == 'media') this.media.push(data); 
                    if ( doc.data().selected == 'world') this.world.push(data); 

                });
                
                this.news.sort( (d1, d2) => d2.data.order - d1.data.order);
                this.media.sort( (d1, d2) => d2.data.order - d1.data.order);
                this.world.sort( (d1, d2) => d2.data.order - d1.data.order);

                if ( this.news.length > 0 ) all.push(this.news[0]);
                if ( this.media.length > 0 ) all.push(this.media[0]);
                if ( this.world.length > 0 ) all.push(this.world[0]);

                all.sort( (d1, d2) => new Date(d2.data.date) - new Date(d1.data.date) );
                this.newsIndex = all.find(x=>x.data.selected=='news') ? all.findIndex(x=>x.data.selected=='news') : 1
                this.worldIndex = all.find(x=>x.data.selected=='world') ?all.findIndex(x=>x.data.selected=='world') : 2
                this.mediaIndex = all.find(x=>x.data.selected=='media') ?all.findIndex(x=>x.data.selected=='media'): 3
                

            
                $(document).ready(function() {

                    var ul = $('ul#ulName'),
                    li = ul.children('li');
                    
                    li.detach().sort(function(a,b) {
                        return $(a).data('sortby') - $(b).data('sortby');  
                    });
                    
                    ul.append(li);
                    $( "#tabs" ).tabs();
                });     

                this.isLoading = false;
            }).catch((error) => {
                // console.log("Error getting document:", error);
                this.isLoading = false;
            });

        }
    }
}
</script>
<style scoped>
.a-font-size-en{
    font-size:14px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Module/News.vue